import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../comun/services/grpc/mapConnectError";
import { TareaEjecucionService } from "../../../generated/grpc/rastro_tarea_ejecucion_pb";
import { grpcTareaEjecucionDatabase } from "../database/GrpcTareaEjecucionDatabase";
import { TareaEjecucionRequest } from "../request/TareaEjecucionRequest";
import { TareaEjecucionResponse } from "../response/TareaEjecucionResponse";
import {
  StoredTareaEjecucionItem,
  toTareaEjecucionResponse,
} from "./TareaEjecucionGrpcService";

/** Variante gRPC-Web de `TareaEjecucionSaveService` (ver ese archivo): mismo
 *  guardado de solo edición (`id`/`tareaId` obligatorios, rechaza creación
 *  del lado server). No invalida ningún cooldown -a diferencia de la
 *  variante REST-: `putOneAsync` ya deja el registro correcto en
 *  `GrpcTareaEjecucionDatabase`. `TareaEjecucionRequest` no trae `fincaId`
 *  (ni en REST), así que el llamador lo pasa acá -lo tiene a mano (ver
 *  `TareaEjecucionEditModal`)- para poder inyectarlo en el registro
 *  guardado, igual que `EscenaGrpcService`: sin esto el registro queda sin
 *  la propiedad que indexa `GrpcTareaEjecucionDatabase` y desaparece del
 *  listado por finca hasta el próximo delta. */
export class TareaEjecucionSaveGrpcService
  implements ISaveService<TareaEjecucionRequest, TareaEjecucionResponse>
{
  constructor(private readonly _fincaId: string) {}

  async saveAsync(
    request: TareaEjecucionRequest,
  ): Promise<TareaEjecucionResponse> {
    const client = createClient(TareaEjecucionService, grpcTransportProvider.get());

    let saved;
    try {
      saved = await client.guardar({
        id: request.id,
        tareaId: request.tareaId,
        detalles: request.detalles.map((detalle) => ({
          productoId: detalle.productoId,
          dosis: detalle.dosis,
        })),
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    const storedItem: StoredTareaEjecucionItem = { ...saved, fincaId: this._fincaId };
    await grpcTareaEjecucionDatabase.putOneAsync(storedItem);
    return toTareaEjecucionResponse(saved);
  }
}
